import Card from "../Card"
import SmallHeadingComponent from "../SmallHeadingComponent"
import SelectPassiveAggregationStrategyField from "../SelectPassiveAggregationStrategyField"
import {
    GetPatientsOfProfessionalResponsePayload,
    isPassiveValueType,
    PassiveValueType,
    ValueType,
    ValueTypeAggregationStrategies
} from "pokal_api"
import { useAppDispatch, useAppSelector } from "../../redux/store/hooks"
import {
    changeAggregationStrategy,
    selectDashboardSelectedPatient,
    selectDashboardSelectedValueType,
    selectValueTypeAggregationStrategies
} from "../../redux/ProfessionalDashboard"
import { useEffect, useState } from "react"
import notNull from "../../util/notNull"
import { ArrayElement } from "../../types/ArrayElement"
import {
    hidePatientDetailViewDataPreferences,
    mockPatientUsed,
    mockPhqValueTypeUsed,
    mockSleepValueTypeUsed,
    selectOnboardingIsRunningState,
    selectOnboardingStep
} from "../../redux/Onboarding"
import mockPatient from "../../onboarding/mock/mockPatient"

function DataViewPreferences() {
    const dispatch = useAppDispatch()

    const strategies = useAppSelector(selectValueTypeAggregationStrategies)

    const step = useAppSelector(selectOnboardingStep)
    const running = useAppSelector(selectOnboardingIsRunningState)

    const fetchedSelectedValueType = useAppSelector(
        selectDashboardSelectedValueType
    )
    const fetchedSelectedPatient = useAppSelector(
        selectDashboardSelectedPatient
    )

    const [selectedPatient, setSelectedPatient] =
        useState<ArrayElement<GetPatientsOfProfessionalResponsePayload> | null>(
            null
        )
    const [selectedValueType, setSelectedValueType] =
        useState<ValueType | null>(null)

    useEffect(() => {
        if (mockPatientUsed(running, step)) {
            setSelectedPatient(mockPatient()[0])
            if (mockPhqValueTypeUsed(running, step)) {
                setSelectedValueType(ValueType.PHQUESTIONNAIRE)
            }
            if (mockSleepValueTypeUsed(running, step)) {
                setSelectedValueType(ValueType.SLEEP_DURATION)
            }
        } else {
            setSelectedPatient(fetchedSelectedPatient)
            setSelectedValueType(fetchedSelectedValueType)
        }
    }, [fetchedSelectedValueType, fetchedSelectedPatient, step, running])

    function getStrategy(): ValueTypeAggregationStrategies | null {
        return selectedValueType === null ? null : strategies[selectedValueType]
    }

    const [aggregationStrageySelection, setAggregationStrategySelection] =
        useState<ValueTypeAggregationStrategies | null>(getStrategy())

    useEffect(() => {
        if (selectedValueType && isPassiveValueType(selectedValueType)) {
            const selection = getStrategy()
            if (
                notNull(selection)
            )
                setAggregationStrategySelection(selection)
        }
    }, [selectedValueType])

    function onSelect(strategy: ValueTypeAggregationStrategies) {
        setAggregationStrategySelection(strategy)
    }

    return (
        <>
            {notNull(selectedValueType) && notNull(selectedPatient) && notNull(aggregationStrageySelection) && (
                <Card
                    blur={hidePatientDetailViewDataPreferences(running, step)}
                    width={"100%"}
                    fill={true}>
                    <div className={"flex flex-col space-y-4"}>
                        <SmallHeadingComponent>
                            Datenansicht-Einstellungen
                        </SmallHeadingComponent>
                        <div className={"flex flex-col space-y-2"}>
                            <div className={"font-bold"}>
                                Präferenzen für die Ansicht gesammelter Daten
                            </div>
                            <SelectPassiveAggregationStrategyField
                                value={aggregationStrageySelection}
                                setValue={onSelect}
                            />
                        </div>
                    </div>
                </Card>
            )}
        </>
    )
}

export default DataViewPreferences
